import { Injectable } from '@angular/core';
import {
  Action,
  NgxsAfterBootstrap,
  State,
  StateContext,
  Store,
} from '@ngxs/store';
import { THERAPIST_LIST_STATE } from '../../../../types/state-name';
import { Therapist } from '../../../../types/therapist';
import { FetchTherapistListAction } from '../actions/therapist-list.action';
import { map, retry, tap } from 'rxjs';
import { TherapistServiceNew } from '../../../../../sdk/src/lib/services/therapist-new.service';
import { AuthService } from '@auth0/auth0-angular';

@State<Array<Therapist>>({
  name: THERAPIST_LIST_STATE,
  defaults: [],
})
@Injectable({
  providedIn: 'root',
})
export class TherapistListState implements NgxsAfterBootstrap {
  constructor(
    private _store: Store,
    private _therapistService: TherapistServiceNew,
    private _authService: AuthService
  ) {}

  ngxsAfterBootstrap() {
    // Check if user is authenticated with Auth0
    this._authService.isAuthenticated$
      .pipe(
        tap((isAuthenticated) => {
          if (isAuthenticated) {
            this._authService.user$
              .pipe(
                tap((user) => {
                  if (user?.sub) {
                    this._store.dispatch(
                      new FetchTherapistListAction(user.sub)
                    );
                  }
                })
              )
              .subscribe();
          }
        })
      )
      .subscribe();
  }

  static getTherapistState(state: any) {
    return state[THERAPIST_LIST_STATE];
  }

  @Action(FetchTherapistListAction)
  fetchTherapistList(stateContext: StateContext<Array<Therapist>>) {
    return this._therapistService.getAllTherapistList().pipe(
      retry(3),
      map((therapistList) => {
        return stateContext.setState([...therapistList]);
      })
    );
  }
}
